import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LetterPage from './LetterPage';
import './App.css';

const SecretGallery = lazy(() => import('./SecretGallery'));
const PrivateLetter = lazy(() => import('./PrivateLetter'));

function PageFallback() {
  return (
    <div className="App route-fallback-wrap">
      <p className="route-fallback">loading…</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      <Routes>
        <Route path="/" element={<LetterPage />} />
        <Route
          path="/gallery"
          element={<Suspense fallback={<PageFallback />}><SecretGallery /></Suspense>}
        />
        <Route
          path="/letter-for-you"
          element={<Suspense fallback={<PageFallback />}><PrivateLetter /></Suspense>}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
